import React, {useEffect, useMemo, useState} from "react";
import ColorField from "./ColorField";
import {useFormContext, useWatch} from "react-hook-form";
import {StyledChip} from "../../components/chips";
import {Typography, useTheme} from "@mui/material";
import chroma from "chroma-js";
import {isEmpty, isString} from "underscore";
import {useColorsWithPreviewStyles} from "./schemaStyles";

export const ColorPreviewField = () => {
  const {classes} = useColorsWithPreviewStyles();
  const theme = useTheme();
  const name = useWatch({name: "name", defaultValue: "Example"});
  const backgroundColor = useWatch({
    name: "backgroundColor",
    defaultValue: theme.palette.chip.background,
  });
  const foregroundColor = useWatch({
    name: "foregroundColor",
    defaultValue: theme.palette.text.primary,
  });
  const computedName = name === "" ? "Example" : name;
  const computedBkgdColor = backgroundColor ?? theme.palette.chip.background;
  const computedForeColor = foregroundColor ?? theme.palette.text.primary;
  const contrastRatio = useMemo(() =>
    chroma.contrast(computedBkgdColor, computedForeColor),
  );
  const contrastThreshold = 4;
  return (
    <div className={classes.previewField}>
      <Typography variant="overline" display="block" gutterBottom>
        Preview
      </Typography>
      <StyledChip
        size="medium"
        data={{
          name: computedName,
          backgroundColor: computedBkgdColor,
          foregroundColor: computedForeColor,
        }}
      />
      <Typography variant="overline" display="block" gutterBottom>
        Contrast:
        {" "}
        {contrastRatio > contrastThreshold ? "Good" : "Too Low"}
      </Typography>
    </div>
  );
};

const ColorsWithPreview = () => {
  const theme = useTheme();
  const {classes} = useColorsWithPreviewStyles();
  const [executeReset, setExecuteReset] = useState();
  const {getValues, setValue} = useFormContext();

  useEffect(() => {
    if (!executeReset) {
      return;
    }
    setExecuteReset();
  }, [executeReset]);

  const fieldValues = getValues();
  if (isEmpty(fieldValues)) {
    return null;
  }

  const handleReset = (whichField) => {
    if (!isString(whichField)) {
      return;
    }
    setExecuteReset(whichField);
    const defaultColor = `reset${whichField[0].toUpperCase()}${whichField.slice(1)}`;
    setValue(whichField, fieldValues[defaultColor]);
  };

  return (
    <div className={classes.preview}>
      <ColorField
        name="foregroundColor"
        label="Text Color"
        defaultValue={theme.palette.primary.ultralight}
        handleReset={handleReset}
        isResetting={executeReset === "foregroundColor"}
      />
      <ColorField
        name="backgroundColor"
        label="Background Color"
        defaultValue={theme.palette.primary.ultralight}
        handleReset={handleReset}
        isResetting={executeReset === "backgroundColor"}
      />
      <ColorPreviewField />
    </div>
  );
};

export default ColorsWithPreview;
